<template>
  <div class="list-materials">
    <AppPageHeader title="Materials" :action="{ title: 'Add material', to: { name: 'CreateMaterial' } }" />

    <BaseTable
      :is-loading="isPending"
      :items="results"
      :fields="tableFields"
      :is-searchable="true"
      :paginate="true"
      :clickable="true"
      :error="error"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
      @on-search="(val) => search(val)"
      @row-selected="onRowSelected"
    >
      <template #image-data="data">
        <img v-if="data.row.image" :src="data.row.image" alt="Material Image" class="w-10 h-10 rounded-full" />
        <span v-else class="i-heroicons-cube size-10"></span>
      </template>
      <template #name-data="data">
        <span class="font-semibold text-slate-950">{{ data.row.name }}</span>
      </template>
      <template #cost-data="data">
        <span>{{ currency(data.row.cost) }}</span>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { currency } from '@/utils'
import BaseTable from '@/components/base/BaseTable.vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import MaterialService from '@/services/MaterialService'
import { useSearchablePagination } from '@/composables/useSearchablePagination'

const tableFields = [
  { key: 'image', label: 'Image'},
  { key: 'name', label: 'Name', sortable: true },
  { key: 'cost', label: 'Cost', sortable: true },
  { key: 'description', label: 'Description' },
]

const numPerPage = ref(25)

const {
  results,
  isPending,
  error,
  search,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination({
  indexName: 'materials',
  service: new MaterialService(),
  numPerPage: numPerPage.value,
  defaultOrderBy: 'name',
  defaultOrderDir: 'asc'
})

const $router = useRouter()
const onRowSelected = (row: any) => {
  $router.push({ name: 'ShowMaterial', params: { id: row.id } })
}

</script>
